import React from 'react';
import { Link } from 'react-router-dom';

const LinkComponent = ({ type, url, newTab, reference, label, appearance, children }) => {
  const href =
    type === 'reference' && typeof reference?.value === 'object' && reference.value.slug
      ? `${reference?.relationTo !== 'pages' ? `/${reference?.relationTo}` : ''}/${
          reference.value.slug
        }`
      : url;

  if (!href) return null;

  if (!appearance && (href || url)) {
    return newTab ? (
      <Link to={href || url} target="_blank" rel="noopener noreferrer">
        {label && label}
        {children && children}
      </Link>
    ) : (
      <Link to={href || url}>
        {label && label}
        {children && children}
      </Link>
    );
  }

  return newTab ? (
    <a href={href} target="_blank" rel="noopener noreferrer">
      {label}
    </a>
  ) : (
    <a href={href}>{label}</a>
  );
};

export default LinkComponent;
